import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../state/ThemeContext';

/**
 * One-tap light/dark toggle. Renders as a small icon button styled like
 * `.btn--ghost btn--icon`. Drop it anywhere — it adapts to the active
 * shell's tokens.
 */
export function ThemeToggle({ className = '' }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`btn btn--ghost btn--icon ${className}`}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
